import cn from "classnames"
import { forwardRef } from "react"

import { Button as ButtonAtnd } from "antd"

import styles from "./Button.module.scss"

import type { ButtonProps } from "."

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (props, ref) => {
    const { type, size, className, dataTestId, ...restProps } = props
    const xsSize = size === "xs"
    const sizeProp = xsSize ? "small" : size
    const nextProps = {
      className: cn(className, {
        [styles.btnXs]: xsSize,
        [styles.size]: xsSize
      }),
      size: sizeProp,
      "data-testid": dataTestId,
      ...restProps
    }

    if (type === "ks") {
      const { className, ...rest } = nextProps

      return (
        <ButtonAtnd
          ref={ref}
          className={cn(styles.ksButton, "ant-btn-ks", className)}
          {...rest}
        />
      )
    }

    if (type === "secondary") {
      const { className, ...rest } = nextProps

      return (
        <ButtonAtnd
          ref={ref}
          className={cn(styles.secondary, className)}
          {...rest}
        />
      )
    }

    return <ButtonAtnd ref={ref} type={type} {...nextProps} />
  }
)

Button.displayName = "Button"
